export default {
  AT_LEAST_8_CHARS: /.{8}/,
};
